import * as base from './base';
import * as crmCore from './crm-core';
import * as store from './store';
import * as async from './async';
import * as global from './global';
import Env from './runTimeEnv';

const util = {
  install: function (Vue) {
    Vue.prototype.$util = this;
  },
};
export default Object.assign(util, base, crmCore, store, { async, Env, global });
